export class CommunicationLogFilterSettings {
    from: Date;
    to: Date;
    filters: string[] = [];
    ownActivity: boolean = true;
    ownerActivity: boolean = true;
    universityActivity: boolean = true;
    domains: number[] = [];
}
